export default () => ( {
    commonStore : Alpine.store( "commonStore" ),
    get isDarkMode() { 
        return Alpine.store( "commonStore" ).isDarkMode;
    },
       
    // methods
    toggleDarkMode() {
        this.commonStore.toggleDarkMode();
    }
} );